import Radio from 'backbone.radio';
/**
 * Helper to create a page title based on useful information. Sets the document title
 * @param arr Array of strings that builds a title
 * @return title string
 */
var globalCh = Radio.channel('global');
const options = globalCh.request('app_options');

let DEFAULT_TITLE = 'impCentral | Electric Imp';

// Use this to manually set a title, rather than have one generated. Takes an array of things to be joined into a title string
let set_title = function(arr) {
    return document.title = arr.join(' | ');
}

let set_default = function() {
    // Check for themes.app_title when using defaults
    const theme = globalCh.request('app_options', 'theme');
    return document.title = theme.app_title ||  DEFAULT_TITLE;
}

export default {
    default: set_default,
    set: set_title,
};
